import { TypographyComponent } from "@gx1/gx-ui-common";
import { useTranslation } from "react-i18next";
import GartnerBuySmartLogoSVG from "../../../assets/images/gartner-buy-smart-logo.svg";
import styles from "./welcome-message.styles.module.scss";

const WelcomeMessageComponent = () => {
  const { t } = useTranslation();

  return (
    <div className={styles.messageContainer}>
      <div className={styles.imgContainer}>
        <img alt={t("Gartner BuySmart logo")} src={GartnerBuySmartLogoSVG} />
      </div>
      <TypographyComponent boldness={"semi"} color="white" element="h1" styling={"h3-xl"}>
        {t("Streamline your team’s path to")}
        {` `}
        <TypographyComponent boldness={"semi"} color="opal" element="span" styling={"h3-xl"}>
          {t("better technology buying decisions")}
        </TypographyComponent>
        <span className={styles.dash}>{`— `}</span>
        {t("fueled by industry-leading insights, workflows, and analysts.")}
      </TypographyComponent>
    </div>
  );
};

export default WelcomeMessageComponent;
